export default __webpack_public_path__ + "static/bonsoirs_logo-28881771fe232afdc36ca4cd141f8177.png";